import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import ModalTemplate from 'theme/molecules/account/ModalTemplate'
import useTranslations from 'hooks/useTranslations'

type Props = {
  specialDelivery: boolean
  onClose: () => void
  'data-cy-state': string
}

export default function DeliveryModal(props: Props) {
  const t = useTranslations<'molecules-account-CartPriceTable'>()
  const normalDelivery = () => (
    <div className="content" data-cy-state="show-normal-delivery-modal">
      <h3 className="title">{t('deliverymodal_shipping_cost')}</h3>
      <div>{t('deliverymodal_shipping_description_text')}</div>
    </div>
  )

  const specialDelivery = () => (
    <div className="content" data-cy-state="show-special-delivery-modal">
      <h3>{t('deliverymodal_bulky_goods')}</h3>
      <div>{t('deliverymodal_bulky_goods_description')}</div>
      <div className="description">
        <div className="small">
          {t('deliverymodal_bulky_goods_description_cost_down_1000_text')}
        </div>
        <div>
          {t('deliverymodal_bulky_goods_description_cost_down_1000', {
            BULKYGOODS: '-',
            __transformers: {
              BULKYGOODS: (_, vars) => (
                <strong> {vars.BULKYGOODS_label} </strong>
              )
            }
          })}
        </div>
      </div>
      <div className="description">
        <div className="small">
          {t('deliverymodal_bulky_goods_description_cost_down_2000_text')}
        </div>
        <div>
          {t('deliverymodal_bulky_goods_description_cost_down_2000', {
            BULKYGOODS: '-',
            __transformers: {
              BULKYGOODS: (_, vars) => (
                <strong> {vars.BULKYGOODS_label} </strong>
              )
            }
          })}
        </div>
      </div>
      <div className="description">
        <div className="small">
          {t('deliverymodal_bulky_goods_description_cost_up_2000_text')}
        </div>
        <div>
          {t('deliverymodal_bulky_goods_description_cost_up_2000', {
            BULKYGOODS: '-',
            __transformers: {
              BULKYGOODS: (_, vars) => (
                <strong> {vars.BULKYGOODS_label} </strong>
              )
            }
          })}
        </div>
      </div>
    </div>
  )

  return (
    <Wrapper
      className="DeliveryModal"
      data-cy-state={props['data-cy-state']}
      onClose={props.onClose}
    >
      {props.specialDelivery ? specialDelivery() : normalDelivery()}
    </Wrapper>
  )
}

const Wrapper = styled(ModalTemplate)`
  > .content {
    ${theme.ty('r-s', null, 'r-base')}
    > h3 {
      ${theme.ty('rc-base', 'bold', 'rc-2xl')}
      margin-bottom: ${theme.spacing('xs')};
    }

    > .description {
      margin-top: ${theme.spacing('m')};
      > .small {
        ${theme.ty('r-xs', null, 'r-s')}
        color: ${theme.colors.shade.b2};
        margin-bottom: ${theme.spacing('xxs')};
      }
    }
  }
`
